import { render, staticRenderFns } from "./Shout.vue?vue&type=template&id=0a34a79e&scoped=true&"
import script from "./Shout.vue?vue&type=script&lang=js&"
export * from "./Shout.vue?vue&type=script&lang=js&"
import style0 from "./Shout.vue?vue&type=style&index=0&id=0a34a79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a34a79e",
  null
  
)

export default component.exports